import React from 'react'

export default ({ icon, ...rest }) => {
  switch (icon) {
    case 'user':
      return <User {...rest} />
    case 'UserPlus':
      return <UserPlus {...rest} />
    case 'userCheck':
      return <UserCheck {...rest} />
    case 'users':
      return <Users {...rest} />
    case 'search':
      return <Search {...rest} />
    case 'trash':
      return <Trash {...rest} />
    case 'calendar':
      return <Calendar {...rest} />
    case 'xCircle':
      return <XCircle {...rest} />
    case 'plusCircle':
      return <PlusCircle {...rest} />
    case 'alertCircle':
      return <AlertCircle {...rest} />
    case 'more':
      return <More {...rest} />
    case 'history':
      return <History {...rest} />
    case 'chevronLeft':
      return <ChevronLeft {...rest} />
    case 'chevronRight':
      return <ChevronRight {...rest} />
    case 'chevronDown':
      return <ChevronDown {...rest} />
    case 'chevronUp':
      return <ChevronUp {...rest} />
    case 'fileText':
      return <FileText {...rest} />
    case 'settings':
      return <Settings {...rest} />
    case 'edit':
      return <Edit {...rest} />
    case 'close':
      return <Close {...rest} />
    case 'checkCircle':
      return <CheckCircle {...rest} />
    case 'checkFilled':
      return <CheckFilled {...rest} />
    case 'errorFilled':
      return <ErrorFilled {...rest} />
    case 'alertFilled':
      return <AtentionFilled {...rest} />
    case 'square':
      return <Square {...rest} />
    case 'squareCheck':
      return <SquareCheck {...rest} />
    case 'helpFilled':
      return <HelpFilled {...rest} />
    case 'infoCircle':
      return <InfoCircle {...rest} />
    case 'block':
      return <Block {...rest} />
    case 'radio':
      return <Radio {...rest} />
    case 'radioFilled':
      return <RadioFilled {...rest} />
    case 'refresh':
      return <Refresh {...rest} />
    default:
      return null
  }
}

const User = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18.4699 14.1972C19.8673 14.1972 21 15.3049 21 16.6714V17.3044C21 18.2883 20.6404 19.2398 19.9862 19.9873C18.2206 22.0045 15.535 23 11.9963 23C8.45709 23 5.77274 22.0041 4.0106 19.9861C3.35834 19.2392 3 18.2892 3 17.3069V16.6714C3 15.3049 4.13275 14.1972 5.53006 14.1972H18.4699ZM18.4699 15.8475H5.53006C5.06476 15.8475 4.68755 16.2163 4.68755 16.6714V17.3069C4.68755 17.8963 4.90256 18.4663 5.29391 18.9144C6.70392 20.5292 8.91561 21.3497 11.9963 21.3497C15.077 21.3497 17.2906 20.5292 18.7042 18.9141C19.0967 18.4657 19.3124 17.8948 19.3124 17.3044V16.6714C19.3124 16.2163 18.9352 15.8475 18.4699 15.8475ZM11.9963 1C15.103 1 17.6215 3.46287 17.6215 6.50098C17.6215 9.53908 15.103 12.002 11.9963 12.002C8.88959 12.002 6.37112 9.53908 6.37112 6.50098C6.37112 3.46287 8.88959 1 11.9963 1ZM11.9963 2.65029C9.8216 2.65029 8.05867 4.3743 8.05867 6.50098C8.05867 8.62765 9.8216 10.3517 11.9963 10.3517C14.171 10.3517 15.9339 8.62765 15.9339 6.50098C15.9339 4.3743 14.171 2.65029 11.9963 2.65029Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const UserPlus = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.2371 11.4737C20.4199 11.4737 23 14.0539 23 17.2368C23 20.4197 20.4199 23 17.2371 23C14.0544 23 11.4742 20.4197 11.4742 17.2368C11.4742 14.0539 14.0544 11.4737 17.2371 11.4737ZM11.4976 13.5686C11.1867 14.0541 10.9357 14.5816 10.7551 15.1407L3.35636 15.141C2.923 15.141 2.57169 15.4924 2.57169 15.9258V16.5311C2.57169 17.0924 2.77194 17.6353 3.13642 18.0621C4.44963 19.6 6.50947 20.3815 9.37866 20.3815C10.0036 20.3815 10.5902 20.3444 11.1392 20.2705C11.3961 20.7891 11.7184 21.2696 12.0943 21.7022C11.2608 21.8701 10.3545 21.9533 9.37866 21.9533C6.08243 21.9533 3.58238 21.0048 1.94121 19.0828C1.33374 18.3714 1 17.4666 1 16.5311V15.9258C1 14.6243 2.05498 13.5693 3.35636 13.5693L11.4976 13.5686ZM17.2371 13.0454L17.143 13.0539C16.9291 13.0927 16.7605 13.2613 16.7217 13.4752L16.7132 13.5694L16.7122 16.7129H13.5698L13.4757 16.7213C13.2618 16.7602 13.0932 16.9288 13.0544 17.1427L13.0459 17.2368L13.0544 17.331C13.0932 17.5449 13.2618 17.7135 13.4757 17.7523L13.5698 17.7608H16.7122L16.7132 20.9043L16.7217 20.9985C16.7605 21.2123 16.9291 21.381 17.143 21.4198L17.2371 21.4282L17.3313 21.4198C17.5451 21.381 17.7138 21.2123 17.7526 20.9985L17.761 20.9043L17.76 17.7608H20.9044L20.9986 17.7523C21.2124 17.7135 21.3811 17.5449 21.4199 17.331L21.4283 17.2368L21.4199 17.1427C21.3811 16.9288 21.2124 16.7602 20.9986 16.7213L20.9044 16.7129H17.76L17.761 13.5694L17.7526 13.4752C17.7138 13.2613 17.5451 13.0927 17.3313 13.0539L17.2371 13.0454ZM9.37866 1C12.2721 1 14.6176 3.34569 14.6176 6.23925C14.6176 9.13281 12.2721 11.4785 9.37866 11.4785C6.48525 11.4785 4.13968 9.13281 4.13968 6.23925C4.13968 3.34569 6.48525 1 9.37866 1ZM9.37866 2.57177C7.35327 2.57177 5.71137 4.21376 5.71137 6.23925C5.71137 8.26474 7.35327 9.90672 9.37866 9.90672C11.404 9.90672 13.0459 8.26474 13.0459 6.23925C13.0459 4.21376 11.404 2.57177 9.37866 2.57177Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const UserCheck = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.2371 11.4737C20.4199 11.4737 23 14.0539 23 17.2368C23 20.4197 20.4199 23 17.2371 23C14.0544 23 11.4742 20.4197 11.4742 17.2368C11.4742 14.0539 14.0544 11.4737 17.2371 11.4737ZM14.4642 16.8664C14.2596 16.6618 13.9279 16.6618 13.7233 16.8664C13.5187 17.071 13.5187 17.4027 13.7233 17.6073L15.8189 19.703C16.0235 19.9076 16.3552 19.9076 16.5598 19.703L20.751 15.5116C20.9556 15.307 20.9556 14.9753 20.751 14.7707C20.5464 14.5661 20.2147 14.5661 20.0101 14.7707L16.1893 18.5916L14.4642 16.8664ZM11.4976 13.5686C11.1867 14.0541 10.9357 14.5816 10.7551 15.1407L3.35636 15.141C2.923 15.141 2.57169 15.4924 2.57169 15.9258V16.5311C2.57169 17.0924 2.77194 17.6353 3.13642 18.0621C4.44963 19.6 6.50947 20.3815 9.37866 20.3815C10.0036 20.3815 10.5902 20.3444 11.1392 20.2705C11.3961 20.7891 11.7184 21.2696 12.0943 21.7022C11.2608 21.8701 10.3545 21.9533 9.37866 21.9533C6.08243 21.9533 3.58238 21.0048 1.94121 19.0828C1.33374 18.3714 1 17.4666 1 16.5311V15.9258C1 14.6243 2.05498 13.5693 3.35636 13.5693L11.4976 13.5686ZM9.37866 1C12.2721 1 14.6176 3.34569 14.6176 6.23925C14.6176 9.13281 12.2721 11.4785 9.37866 11.4785C6.48525 11.4785 4.13968 9.13281 4.13968 6.23925C4.13968 3.34569 6.48525 1 9.37866 1ZM9.37866 2.57177C7.35327 2.57177 5.71137 4.21376 5.71137 6.23925C5.71137 8.26474 7.35327 9.90672 9.37866 9.90672C11.404 9.90672 13.0459 8.26474 13.0459 6.23925C13.0459 4.21376 11.404 2.57177 9.37866 2.57177Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Users = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.2 14.1568L13.1 14.1579C14.2592 14.1579 15.2099 15.0592 15.294 16.2034L15.3 16.3684V18.0263C15.2989 21.8947 11.2124 23 8.15 23C5.15565 23 1.18116 21.9433 1.006 18.2801L1 18.0263V16.3673C1 15.2026 1.89804 14.2473 3.03589 14.1629L3.2 14.1568ZM15.542 14.1579H20.8C21.9592 14.1579 22.9099 15.0602 22.994 16.2035L23 16.3684V17.4737C22.9989 20.858 19.8562 21.8947 17.5 21.8947C16.752 21.8947 15.9259 21.7886 15.146 21.5388C15.5156 21.1122 15.8137 20.6248 16.0282 20.0722C16.6255 20.2103 17.1865 20.2368 17.5 20.2368L17.7932 20.2303C18.877 20.1826 21.1882 19.8286 21.3419 17.7002L21.35 17.4737V16.3684C21.35 16.0973 21.1544 15.8715 20.8985 15.8247L20.8 15.8158H16.3439C16.2515 15.2616 16.021 14.7583 15.6899 14.3345L15.542 14.1579H20.8H15.542ZM3.2 15.8147L3.08928 15.8257C2.95246 15.8537 2.859 15.9283 2.8106 15.9761C2.76308 16.0247 2.68881 16.1179 2.661 16.2556L2.65 16.3673V18.0263C2.65 19.1415 3.145 19.9296 4.2087 20.5043C5.11747 20.9961 6.41146 21.2938 7.80084 21.3367L8.15 21.3421L8.49915 21.3367C9.88838 21.2938 11.1815 20.9961 12.0913 20.5043C13.0875 19.9655 13.5858 19.2392 13.6442 18.2307L13.65 18.0252V16.3684C13.65 16.0973 13.4544 15.8715 13.1985 15.8247L13.1 15.8158L3.2 15.8147ZM8.15 2C10.8835 2 13.1 4.22711 13.1 6.97368C13.1 9.72026 10.8835 11.9474 8.15 11.9474C5.4165 11.9474 3.2 9.72026 3.2 6.97368C3.2 4.22711 5.4165 2 8.15 2ZM18.05 4.21053C20.1763 4.21053 21.9 5.94247 21.9 8.07895C21.9 10.2154 20.1763 11.9474 18.05 11.9474C15.9237 11.9474 14.2 10.2154 14.2 8.07895C14.2 5.94247 15.9237 4.21053 18.05 4.21053ZM8.15 3.65789C6.3306 3.65789 4.85 5.14558 4.85 6.97368C4.85 8.80179 6.3306 10.2895 8.15 10.2895C9.9694 10.2895 11.45 8.80179 11.45 6.97368C11.45 5.14558 9.9694 3.65789 8.15 3.65789ZM18.05 5.86842C16.8367 5.86842 15.85 6.85984 15.85 8.07895C15.85 9.29805 16.8367 10.2895 18.05 10.2895C19.2633 10.2895 20.25 9.29805 20.25 8.07895C20.25 6.85984 19.2633 5.86842 18.05 5.86842Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Search = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.86111 1C14.755 1 18.7222 4.96725 18.7222 9.86111C18.7222 11.9778 17.98 13.9212 16.7417 15.4452L22.7315 21.4352C23.0895 21.7931 23.0895 22.3735 22.7315 22.7315C22.4061 23.057 21.8968 23.0865 21.538 22.8203L21.4352 22.7315L15.4452 16.7417C13.9212 17.98 11.9778 18.7222 9.86111 18.7222C4.96725 18.7222 1 14.755 1 9.86111C1 4.96725 4.96725 1 9.86111 1ZM9.86111 2.83333C5.97978 2.83333 2.83333 5.97978 2.83333 9.86111C2.83333 13.7424 5.97978 16.8889 9.86111 16.8889C13.7424 16.8889 16.8889 13.7424 16.8889 9.86111C16.8889 5.97978 13.7424 2.83333 9.86111 2.83333Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Trash = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C13.8735 1 15.4046 2.47368 15.508 4.3305L15.5135 4.53086H21.1892C21.637 4.53086 22 4.89567 22 5.34568C22 5.75819 21.695 6.0991 21.2992 6.15306L21.1892 6.16049H20.3286L18.9447 20.3048C18.8013 21.7705 17.6199 22.9022 16.1758 22.994L15.986 23H8.01398C6.54848 23 5.31206 21.9293 5.07982 20.494L5.05528 20.3048L3.67027 6.16049H2.81081C2.40033 6.16049 2.06109 5.85396 2.0074 5.45624L2 5.34568C2 4.93317 2.30503 4.59226 2.70079 4.5383L2.81081 4.53086H8.48649C8.48649 2.58082 10.0595 1 12 1ZM18.6995 6.16049H5.29946L6.66912 20.1453C6.73262 20.7941 7.2436 21.299 7.87659 21.3634L8.01398 21.3704H15.986C16.6348 21.3704 17.1848 20.9088 17.3105 20.282L17.3309 20.1453L18.6995 6.16049ZM13.8919 9.14815C14.3024 9.14815 14.6416 9.45469 14.6953 9.8524L14.7027 9.96296V17.5679C14.7027 18.0179 14.3397 18.3827 13.8919 18.3827C13.4814 18.3827 13.1422 18.0762 13.0885 17.6785L13.0811 17.5679V9.96296C13.0811 9.51295 13.4441 9.14815 13.8919 9.14815ZM10.1081 9.14815C10.5186 9.14815 10.8578 9.45469 10.9115 9.8524L10.9189 9.96296V17.5679C10.9189 18.0179 10.5559 18.3827 10.1081 18.3827C9.69763 18.3827 9.35839 18.0762 9.3047 17.6785L9.2973 17.5679V9.96296C9.2973 9.51295 9.66031 9.14815 10.1081 9.14815ZM12 2.62963C11.0074 2.62963 10.1933 3.39785 10.1144 4.37493L10.1081 4.53086H13.8919C13.8919 3.48084 13.0449 2.62963 12 2.62963Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Calendar = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.0278 1C21.2216 1 23 2.77842 23 4.97222V19.0278C23 21.2216 21.2216 23 19.0278 23H4.97222C2.77842 23 1 21.2216 1 19.0278V4.97222C1 2.77842 2.77842 1 4.97222 1H19.0278ZM21.1667 7.72222H2.83333V19.0278C2.83333 20.2091 3.79095 21.1667 4.97222 21.1667H19.0278C20.2091 21.1667 21.1667 20.2091 21.1667 19.0278V7.72222ZM6.80556 15.0556C7.64932 15.0556 8.33333 15.7396 8.33333 16.5833C8.33333 17.4271 7.64932 18.1111 6.80556 18.1111C5.96179 18.1111 5.27778 17.4271 5.27778 16.5833C5.27778 15.7396 5.96179 15.0556 6.80556 15.0556ZM12 15.0556C12.8438 15.0556 13.5278 15.7396 13.5278 16.5833C13.5278 17.4271 12.8438 18.1111 12 18.1111C11.1562 18.1111 10.4722 17.4271 10.4722 16.5833C10.4722 15.7396 11.1562 15.0556 12 15.0556ZM6.80556 10.1667C7.64932 10.1667 8.33333 10.8507 8.33333 11.6944C8.33333 12.5382 7.64932 13.2222 6.80556 13.2222C5.96179 13.2222 5.27778 12.5382 5.27778 11.6944C5.27778 10.8507 5.96179 10.1667 6.80556 10.1667ZM12 10.1667C12.8438 10.1667 13.5278 10.8507 13.5278 11.6944C13.5278 12.5382 12.8438 13.2222 12 13.2222C11.1562 13.2222 10.4722 12.5382 10.4722 11.6944C10.4722 10.8507 11.1562 10.1667 12 10.1667ZM17.1944 10.1667C18.0382 10.1667 18.7222 10.8507 18.7222 11.6944C18.7222 12.5382 18.0382 13.2222 17.1944 13.2222C16.3507 13.2222 15.6667 12.5382 15.6667 11.6944C15.6667 10.8507 16.3507 10.1667 17.1944 10.1667ZM19.0278 2.83333H4.97222C3.79095 2.83333 2.83333 3.79095 2.83333 4.97222V5.88889H21.1667V4.97222C21.1667 3.79095 20.2091 2.83333 19.0278 2.83333Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const XCircle = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.65C6.83614 2.65 2.65 6.83614 2.65 12C2.65 17.1639 6.83614 21.35 12 21.35C17.1639 21.35 21.35 17.1639 21.35 12C21.35 6.83614 17.1639 2.65 12 2.65ZM15.7908 8.03676L15.8834 8.11664C16.1763 8.40953 16.2029 8.86786 15.9632 9.19083L15.8834 9.28336L13.1671 12L15.8834 14.7166C16.1763 15.0095 16.2029 15.4679 15.9632 15.7908L15.8834 15.8834C15.5905 16.1763 15.1321 16.2029 14.8092 15.9632L14.7166 15.8834L12 13.1671L9.28336 15.8834C8.99047 16.1763 8.53214 16.2029 8.20917 15.9632L8.11664 15.8834C7.82374 15.5905 7.79712 15.1321 8.03676 14.8092L8.11664 14.7166L10.8329 12L8.11664 9.28336C7.82374 8.99047 7.79712 8.53214 8.03676 8.20917L8.11664 8.11664C8.40953 7.82374 8.86786 7.79712 9.19083 8.03676L9.28336 8.11664L12 10.8329L14.7166 8.11664C15.0095 7.82374 15.4679 7.79712 15.7908 8.03676Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const PlusCircle = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.7782 4.22202C24.0739 8.51779 24.0739 15.4826 19.7782 19.7784C15.4824 24.0741 8.51759 24.0741 4.22183 19.7784C-0.073942 15.4826 -0.073942 8.51779 4.22183 4.22202C8.51759 -0.0737451 15.4824 -0.0737451 19.7782 4.22202ZM18.6114 5.38875C14.96 1.73735 9.03995 1.73735 5.38855 5.38875C1.73715 9.04015 1.73715 14.9602 5.38855 18.6116C9.03995 22.263 14.96 22.263 18.6114 18.6116C22.2629 14.9602 22.2629 9.04015 18.6114 5.38875ZM17.483 11.8783L17.4919 12.0002C17.4919 12.4144 17.1866 12.7573 16.7888 12.8163L16.6669 12.8252L12.8253 12.8255L12.825 16.6671C12.825 17.0813 12.5197 17.4242 12.1219 17.4832L12 17.4921C11.5858 17.4921 11.2429 17.1868 11.1839 16.789L11.175 16.6671L11.1747 12.8255L7.3331 12.8252C6.91888 12.8252 6.57597 12.5199 6.51704 12.1221L6.5081 12.0002C6.5081 11.586 6.81336 11.2431 7.21118 11.1841L7.3331 11.1752L11.1747 11.1749L11.175 7.33329C11.175 6.91908 11.4803 6.57616 11.8781 6.51724L12 6.50829C12.4142 6.50829 12.7571 6.81355 12.8161 7.21138L12.825 7.33329L12.8253 11.1749L16.6669 11.1752C17.0811 11.1752 17.424 11.4805 17.483 11.8783Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const AlertCircle = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C18.0753 1 23 5.9258 23 12C23 18.0742 18.0753 23 12 23C5.9247 23 1 18.0742 1 12C1 5.9258 5.9247 1 12 1ZM12 2.8337C6.9455 2.8337 2.8337 6.9455 2.8337 12C2.8337 17.0545 6.9455 21.1663 12 21.1663C17.0545 21.1663 21.1663 17.0545 21.1663 12C21.1663 6.9455 17.0545 2.8337 12 2.8337ZM11.9985 14.7525C12.6052 14.7525 13.0971 15.2443 13.0971 15.851C13.0971 16.4577 12.6052 16.9495 11.9985 16.9495C11.3918 16.9495 10.9 16.4577 10.9 15.851C10.9 15.2443 11.3918 14.7525 11.9985 14.7525ZM11.9939 6.5C12.4116 6.49967 12.757 6.80976 12.8119 7.2124L12.8196 7.32434L12.8235 12.2761C12.8239 12.7317 12.4548 13.1014 11.9992 13.1018C11.5815 13.1021 11.2361 12.792 11.1811 12.3894L11.1735 12.2774L11.1696 7.32566C11.1692 6.87003 11.5383 6.50037 11.9939 6.5Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const More = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="5" r="1"></circle>
    <circle cx="12" cy="19" r="1"></circle>
  </svg>
)

const History = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C9.91047 23 7.90488 22.4155 6.17099 21.3302C5.46471 20.8881 4.81052 20.3669 4.22137 19.7777C3.63132 19.1876 3.10957 18.5323 2.66712 17.8247C1.58349 16.0918 1 14.0878 1 12C1 11.6649 1.01501 11.3315 1.04485 11.0006C1.09031 10.4963 1.53591 10.1244 2.04013 10.1699C2.54434 10.2154 2.91624 10.661 2.87078 11.1652C2.84587 11.4415 2.83333 11.7199 2.83333 12C2.83333 13.7415 3.31888 15.4091 4.22157 16.8527C4.59044 17.4426 5.02561 17.9892 5.51781 18.4814C6.00926 18.9729 6.55488 19.4076 7.14372 19.7762C8.58809 20.6803 10.257 21.1667 12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333C9.06998 2.83333 6.3772 4.21788 4.66391 6.5024L8.03289 6.50256C8.53916 6.50256 8.94956 6.91296 8.94956 7.41923C8.94956 7.8833 8.60471 8.26683 8.15728 8.32752L8.03289 8.33589H2.52778C2.06371 8.33589 1.68018 7.99104 1.61948 7.54361L1.61111 7.41923V1.91923C1.61111 1.41296 2.02152 1.00256 2.52778 1.00256C2.99185 1.00256 3.37538 1.34741 3.43608 1.79484L3.44444 1.91923L3.44322 5.08648C5.50495 2.53515 8.62212 1 12 1ZM11.0833 5.88889C11.5472 5.88889 11.9309 6.23396 11.9916 6.68122L12 6.80556V12H14.75C15.256 12 15.6667 12.4107 15.6667 12.9167C15.6667 13.3805 15.3216 13.7642 14.8743 13.825L14.75 13.8333H11.0833C10.6195 13.8333 10.2358 13.4883 10.175 13.041L10.1667 12.9167V6.80556C10.1667 6.29956 10.5773 5.88889 11.0833 5.88889Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const ChevronLeft = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
)

const ChevronRight = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: 'rotate(90deg)' }}
  >
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
)

const ChevronDown = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
)

const ChevronUp = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: 'rotate(180deg)' }}
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
)

const FileText = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
)

const Settings = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0125 1C12.8749 1.00954 13.7339 1.10522 14.5757 1.28548C14.9432 1.36417 15.218 1.65832 15.2597 2.0176L15.4597 3.7402C15.5502 4.53113 16.2457 5.13019 17.0748 5.13103C17.2977 5.13136 17.5182 5.0868 17.7241 4.99931L19.3698 4.30515C19.7121 4.16078 20.112 4.23949 20.3675 4.50152C21.5568 5.72115 22.4425 7.18388 22.958 8.77965C23.0692 9.12375 22.9413 9.4977 22.6392 9.71146L21.1805 10.7439C20.7644 11.0374 20.5187 11.5036 20.5187 11.9994C20.5187 12.4952 20.7644 12.9614 21.1814 13.2556L22.6414 14.2884C22.9435 14.5021 23.0716 14.8761 22.9604 15.2203C22.4451 16.8158 21.5598 18.2784 20.3712 19.4982C20.116 19.7602 19.7164 19.8391 19.3741 19.6951L17.7217 19C17.249 18.8014 16.7061 18.8305 16.2593 19.0784C15.8125 19.3263 15.5152 19.7635 15.4585 20.256L15.2598 21.9784C15.2188 22.3335 14.9499 22.6257 14.5879 22.7084C12.886 23.0972 11.1128 23.0972 9.41094 22.7084C9.0489 22.6257 8.77999 22.3335 8.73903 21.9784L8.54067 20.2585C8.4824 19.7669 8.18463 19.3311 7.73823 19.084C7.29184 18.837 6.74982 18.808 6.27865 19.0055L4.62589 19.7008C4.28356 19.8448 3.88385 19.7658 3.62858 19.5037C2.43932 18.2824 1.55406 16.8181 1.03942 15.2208C0.928577 14.8768 1.05665 14.5031 1.3586 14.2895L2.81949 13.2561C3.23559 12.9625 3.48135 12.4963 3.48135 12.0005C3.48135 11.5048 3.23559 11.0386 2.81894 10.7446L1.35897 9.71298C1.05657 9.4993 0.928382 9.12511 1.03962 8.78078C1.55514 7.18501 2.44087 5.72228 3.63016 4.50265C3.88568 4.24062 4.28558 4.16191 4.62786 4.30628L6.27327 5.00031C6.74671 5.19982 7.29101 5.16968 7.73982 4.91792C8.18668 4.66903 8.48418 4.23144 8.54162 3.73889L8.74145 2.0176C8.78318 1.65814 9.05825 1.36389 9.42595 1.28537C10.2687 1.1054 11.1287 1.00976 12.0125 1ZM12.0127 2.6922C11.4792 2.69823 10.9473 2.74244 10.4212 2.82433L10.2932 3.92678C10.1735 4.95288 9.55429 5.86373 8.62651 6.38046C7.69305 6.90411 6.55496 6.96712 5.56471 6.54984L4.50924 6.10465C3.83723 6.88781 3.30236 7.77078 2.92564 8.71884L3.86303 9.38122C4.73112 9.99364 5.24381 10.9662 5.24381 12.0005C5.24381 13.0349 4.73112 14.0074 3.86395 14.6192L2.92508 15.2834C3.30147 16.2331 3.83643 17.1177 4.5089 17.9024L5.57241 17.455C6.55715 17.0422 7.6875 17.1026 8.61841 17.6179C9.54933 18.1331 10.1703 19.042 10.2921 20.0697L10.4202 21.1797C11.4655 21.3504 12.5334 21.3504 13.5787 21.1797L13.7067 20.0697C13.8251 19.0424 14.4454 18.1304 15.3774 17.6132C16.3094 17.096 17.4421 17.0353 18.4286 17.4498L19.4913 17.8968C20.1632 17.1134 20.6979 16.2302 21.0745 15.282L20.137 14.6187C19.2689 14.0063 18.7562 13.0337 18.7562 11.9994C18.7562 10.9651 19.2689 9.99251 20.1359 9.38086L21.0722 8.71818C20.6955 7.76994 20.1605 6.88681 19.4884 6.10352L18.4351 6.54781C18.0058 6.73018 17.5415 6.82404 17.0725 6.82334C15.3457 6.8216 13.8964 5.57325 13.7079 3.92638L13.58 2.82397C13.0565 2.74218 12.53 2.69809 12.0127 2.6922ZM11.9978 7.76919C14.4313 7.76919 16.404 9.66338 16.404 12C16.404 14.3366 14.4313 16.2308 11.9978 16.2308C9.56439 16.2308 7.59168 14.3366 7.59168 12C7.59168 9.66338 9.56439 7.76919 11.9978 7.76919ZM11.9978 9.46151C10.5378 9.46151 9.35415 10.598 9.35415 12C9.35415 13.4019 10.5378 14.5384 11.9978 14.5384C13.4579 14.5384 14.6415 13.4019 14.6415 12C14.6415 10.598 13.4579 9.46151 11.9978 9.46151Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Edit = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
)

const Close = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : 'currentColor'}
    strokeWidth={stroke ? stroke : '2'}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
)

const CheckCircle = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.65C6.83614 2.65 2.65 6.83614 2.65 12C2.65 17.1639 6.83614 21.35 12 21.35C17.1639 21.35 21.35 17.1639 21.35 12C21.35 6.83614 17.1639 2.65 12 2.65ZM10.625 13.5833L15.5416 8.66664C15.8638 8.34445 16.3862 8.34445 16.7084 8.66664C17.0013 8.95953 17.0279 9.41786 16.7882 9.74083L16.7084 9.83336L11.2084 15.3334C10.9155 15.6263 10.4571 15.6529 10.1342 15.4132L10.0416 15.3334L7.29164 12.5834C6.96945 12.2612 6.96945 11.7388 7.29164 11.4166C7.58453 11.1237 8.04286 11.0971 8.36583 11.3368L8.45836 11.4166L10.625 13.5833L15.5416 8.66664L10.625 13.5833Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const CheckFilled = ({ color, stroke }) => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <circle cx="10" cy="10" r="10" fill={color ? color : 'currentColor'} />
    <polyline
      points="14 7.5 9 12.5 6.5 10"
      fill="none"
      stroke="#fff"
      strokeWidth={stroke ? stroke : '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ErrorFilled = ({ color, stroke }) => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="12" fill={color ? color : 'currentColor'} />
    <line
      className="cls-1"
      x1="15.6"
      y1="8.4"
      x2="8.4"
      y2="15.6"
      fill="none"
      stroke="#fff"
      strokeWidth={stroke ? stroke : '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      className="cls-1"
      x1="8.4"
      y1="8.4"
      x2="15.6"
      y2="15.6"
      fill="none"
      stroke="#fff"
      strokeWidth={stroke ? stroke : '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const AtentionFilled = ({ color, stroke }) => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="12" fill={color ? color : 'currentColor'} />
    <line
      className="cls-1"
      x1="12"
      y1="7.2"
      x2="12"
      y2="12"
      fill="none"
      stroke="#fff"
      strokeWidth={stroke ? stroke : '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      className="cls-1"
      x1="12"
      y1="16.8"
      x2="12.01"
      y2="16.8"
      fill="none"
      stroke="#fff"
      strokeWidth={stroke ? stroke : '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Square = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.36111 1H19.6389C21.4952 1 23 2.50482 23 4.36111V19.6389C23 21.4952 21.4952 23 19.6389 23H4.36111C2.50482 23 1 21.4952 1 19.6389V4.36111C1 2.50482 2.50482 1 4.36111 1ZM4.36111 2.83333C3.51734 2.83333 2.83333 3.51734 2.83333 4.36111V19.6389C2.83333 20.4827 3.51734 21.1667 4.36111 21.1667H19.6389C20.4827 21.1667 21.1667 20.4827 21.1667 19.6389V4.36111C21.1667 3.51734 20.4827 2.83333 19.6389 2.83333H4.36111Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const SquareCheck = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2244 7.99073C17.5823 8.34872 17.5823 8.92912 17.2243 9.28709L11.1132 15.3979C10.7552 15.7559 10.1748 15.7559 9.81686 15.3979L7.36778 12.9488C7.0098 12.5909 7.0098 12.0105 7.36778 11.6525C7.72576 11.2945 8.30616 11.2945 8.66414 11.6525L10.4651 13.4534L15.928 7.9907C16.286 7.63273 16.8664 7.63274 17.2244 7.99073Z"
      fill={color ? color : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 3.75C1 2.23122 2.23122 1 3.75 1H20.25C21.7688 1 23 2.23122 23 3.75V20.25C23 21.7688 21.7688 23 20.25 23H3.75C2.23122 23 1 21.7688 1 20.25V3.75ZM3.75 2.83334C3.24374 2.83334 2.83333 3.24374 2.83333 3.75V20.25C2.83333 20.7563 3.24374 21.1667 3.75 21.1667H20.25C20.7563 21.1667 21.1667 20.7563 21.1667 20.25V3.75C21.1667 3.24374 20.7563 2.83334 20.25 2.83334H3.75Z"
      fill="currentColor"
    />
  </svg>
)

const HelpFilled = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C18.0753 1 23 5.9258 23 12C23 18.0742 18.0753 23 12 23C5.9247 23 1 18.0742 1 12C1 5.9258 5.9247 1 12 1ZM12 15.85C11.3925 15.85 10.9 16.3425 10.9 16.95C10.9 17.5575 11.3925 18.05 12 18.05C12.6075 18.05 13.1 17.5575 13.1 16.95C13.1 16.3425 12.6075 15.85 12 15.85ZM12 6.225C10.3293 6.225 8.975 7.57934 8.975 9.25C8.975 9.70564 9.34437 10.075 9.8 10.075C10.2177 10.075 10.5628 9.76463 10.6175 9.36195L10.625 9.25C10.625 8.49061 11.2406 7.875 12 7.875C12.7594 7.875 13.375 8.49061 13.375 9.25C13.375 9.8427 13.2265 10.1358 12.6656 10.7154L12.5166 10.8666C11.5507 11.8325 11.175 12.4588 11.175 13.65C11.175 14.1056 11.5444 14.475 12 14.475C12.4556 14.475 12.825 14.1056 12.825 13.65C12.825 13.0573 12.9735 12.7642 13.5344 12.1846L13.6834 12.0334C14.6493 11.0675 15.025 10.4412 15.025 9.25C15.025 7.57934 13.6707 6.225 12 6.225Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const InfoCircle = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.64974C6.836 2.64974 2.64974 6.836 2.64974 12C2.64974 17.164 6.836 21.3503 12 21.3503C17.164 21.3503 21.3503 17.164 21.3503 12C21.3503 6.836 17.164 2.64974 12 2.64974ZM11.996 10.3492C12.4136 10.3489 12.7589 10.659 12.8138 11.0616L12.8214 11.1735L12.8254 17.2243C12.8257 17.6799 12.4566 18.0495 12.001 18.0498C11.5834 18.05 11.2381 17.7399 11.1832 17.3373L11.1756 17.2254L11.1717 11.1746C11.1714 10.719 11.5404 10.3495 11.996 10.3492ZM12.0005 6.50225C12.6071 6.50225 13.0989 6.994 13.0989 7.60061C13.0989 8.20721 12.6071 8.69896 12.0005 8.69896C11.3939 8.69896 10.9021 8.20721 10.9021 7.60061C10.9021 6.994 11.3939 6.50225 12.0005 6.50225Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Block = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM19.1691 5.99739L5.99739 19.1691C7.62151 20.5304 9.71504 21.35 12 21.35C17.1639 21.35 21.35 17.1639 21.35 12C21.35 9.71504 20.5304 7.62151 19.1691 5.99739ZM12 2.65C6.83614 2.65 2.65 6.83614 2.65 12C2.65 14.285 3.46964 16.3785 4.83094 18.0026L18.0026 4.83094C16.3785 3.46964 14.285 2.65 12 2.65Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Radio = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21.3503C6.836 21.3503 2.64974 17.164 2.64974 12C2.64974 6.836 6.836 2.64974 12 2.64974C17.164 2.64974 21.3503 6.836 21.3503 12C21.3503 17.164 17.164 21.3503 12 21.3503Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const RadioFilled = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.64974C6.836 2.64974 2.64974 6.836 2.64974 12C2.64974 17.164 6.836 21.3503 12 21.3503C17.164 21.3503 21.3503 17.164 21.3503 12C21.3503 6.836 17.164 2.64974 12 2.64974Z"
      fill="currentColor"
    />
    <path
      d="M18.5932 11.9963C18.5932 8.35295 15.6397 5.39941 11.9963 5.39941C8.35295 5.39941 5.39941 8.35295 5.39941 11.9963C5.39941 15.6397 8.35295 18.5932 11.9963 18.5932C15.6397 18.5932 18.5932 15.6397 18.5932 11.9963Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)

const Refresh = ({ color, stroke }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.628 5.02151C7.88636 5.35853 7.82118 5.8401 7.48241 6.09713C5.643 7.49271 4.54286 9.65491 4.54286 12C4.54286 15.8229 7.44943 18.9704 11.184 19.3747L10.4883 18.6822C10.1871 18.3825 10.1871 17.8966 10.4883 17.5969C10.7622 17.3244 11.1908 17.2996 11.4928 17.5226L11.5793 17.5969L13.6364 19.6434C13.9103 19.9158 13.9352 20.3422 13.7111 20.6426L13.6364 20.7287L11.5793 22.7752C11.278 23.0749 10.7896 23.0749 10.4883 22.7752C10.2145 22.5028 10.1896 22.0764 10.4136 21.776L10.4883 21.6899L11.26 20.9237C6.6356 20.5493 3 16.697 3 12C3 9.17097 4.32869 6.55957 6.54679 4.87667C6.88556 4.61964 7.36964 4.68449 7.628 5.02151ZM13.5117 1.22478C13.8129 1.52448 13.8129 2.0104 13.5117 2.31011L12.741 3.07642C17.3649 3.45131 21 7.30334 21 12C21 14.706 19.785 17.216 17.7283 18.9061C17.3998 19.176 16.9136 19.1299 16.6423 18.8031C16.3709 18.4764 16.4173 17.9926 16.7457 17.7227C18.4513 16.3211 19.4571 14.2432 19.4571 12C19.4571 8.17749 16.5511 5.03021 12.817 4.62541L13.5117 5.3178C13.8129 5.61751 13.8129 6.10342 13.5117 6.40313C13.2104 6.70283 12.722 6.70283 12.4207 6.40313L10.3636 4.35662C10.0623 4.05691 10.0623 3.57099 10.3636 3.27129L12.4207 1.22478C12.722 0.925074 13.2104 0.925074 13.5117 1.22478Z"
      fill={color ? color : 'currentColor'}
    />
  </svg>
)
